import type { LeaderboardConfig } from "@expert/app-config/types";

import { ScrollArea, Stack } from "@mantine/core";

import { Challenge } from "@/sales-tools/challenges/Challenge";

import { LeaderboardWidget } from "../../leaderboard/components/LeaderboardWidget";
import { StatsHeader } from "./StatsHeader";

interface WidgetPanelProps {
    opened: boolean;
    showStatsHeader: boolean;
    showChallenges: boolean;
    hasLeaderboards: boolean;
    leaderboards: LeaderboardConfig[];
    onStatsHeaderClick: () => void;
}

export function WidgetPanel({
    opened,
    showStatsHeader,
    showChallenges,
    hasLeaderboards,
    leaderboards,
    onStatsHeaderClick,
}: WidgetPanelProps) {
    return (
        <Stack flex={1} gap={0} data-testid="widget-container" bg={opened ? "#271a34" : "dark.7"} w={"100%"}>
            <ScrollArea type="hover" scrollbarSize={0}>
                {showStatsHeader && <StatsHeader opened={opened} onClick={onStatsHeaderClick} />}
                {showChallenges && <Challenge />}
                {hasLeaderboards && <LeaderboardWidget leaderboards={leaderboards} />}
            </ScrollArea>
        </Stack>
    );
}
